// extracted by mini-css-extract-plugin
export default {"checkbox":"Switcher_checkbox__tyxQm","icon":"Switcher_icon__0NGRk","switch":"Switcher_switch__hjvKa","open":"Switcher_open__UtfrV"};